import React, { useEffect, useState } from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/Administration/globalSetting/form'
import { toast } from 'react-toastify'
import { v1_fetch_globalSetting, v1_update_globalSetting } from '../../../actions/v1/globalSettings'
const Add = (props) => {
    const onSubmit = (model) => {
        v1_update_globalSetting(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
            }
            else {
                toast.error(res.error)
            }
        })
    }

    const [data, setData] = useState(null);

    useEffect(() => {
        v1_fetch_globalSetting().then((res) => {
            if (res.status) {
                setData(res.result)
            }
            else {
                toast.error(res.error)
            }
        })
    }, [])
    return (
        <React.Fragment>
            <Layout
                title={'Update Global Settings'}>
                <Form
                    data={data}
                    onSubmit={onSubmit}
                    buttonName={'Update'}
                />
            </Layout>

        </React.Fragment>
    )
}

export default Add